import * as React from "react"

function CheckIcon({ color }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={26}
            height={26}
            viewBox="0 0 26 26"
        >
            <g fill={color} fillRule="nonzero">
                <path d="M21.85 3.749A12.708 12.708 0 0012.8 0C9.38 0 6.167 1.331 3.749 3.749S0 9.381 0 12.8c0 3.419 1.331 6.633 3.749 9.05A12.708 12.708 0 0012.8 25.6c3.419 0 6.633-1.331 9.05-3.75a12.708 12.708 0 003.75-9.05c0-3.419-1.331-6.633-3.75-9.051zM12.8 24.1c-6.23 0-11.3-5.07-11.3-11.3S6.57 1.5 12.8 1.5s11.3 5.07 11.3 11.3-5.07 11.3-11.3 11.3z" />
                <path d="M18.915 8.693a.749.749 0 00-1.06 0l-6.623 6.623-3.487-3.486a.749.749 0 10-1.06 1.06l4.016 4.017a.752.752 0 001.061 0l7.153-7.153a.75.75 0 000-1.061z" />
            </g>
        </svg>
    )
}

export default CheckIcon
